<template>
  <div class="sensitive-words-manage app-region blank-t-v blank-l-h blank-r-h">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>敏感词名称</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入敏感词名称" v-model="table.search.name"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>敏感词状态</p>
          </a-col>
          <a-col>
            <a-select v-model="table.search.status" class="app-block" placeholder="请选择敏感词状态">
              <a-select-option :value="1">启用</a-select-option>
              <a-select-option :value="0">禁用</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-row class="mg-normal">
      <a-col>
        <a-space>
          <a-button type="primary" @click="newSensitiveWords()">新增敏感词</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id" :pagination="table.page" @change="handlePageChange">
      <template slot="state" slot-scope="text, data">
        <a-switch :checked="data.status === 1" :loading="data.stateLoading" @click="stateChange(data)"></a-switch>
      </template>
      <template slot="action" slot-scope="text, data">
        <a-space>
          <a-button type="link" @click="editSensitiveWords(data)">编辑</a-button>
          <a-button type="link" @click="deleteSensitiveWords(data)">删除</a-button>
        </a-space>
      </template>
    </a-table>
    <!-- 新增敏感词 -->
    <a-modal :title="addModal.title" :confirm-loading="addModal.loading" v-model="addModal.show" @ok="confirmAddModal" destroy-on-close centered>
      <a-form-model ref="form" :model="form" layout="vertical" :rules="rules">
        <a-form-model-item label="敏感词名称" prop="name">
          <a-textarea v-model="form.name" placeholder="请输入敏感词名称（可一次添加多个， 每个单独一行）"></a-textarea>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 编辑敏感词 -->
    <a-modal :title="editModal.title" :confirm-loading="editModal.loading" v-model="editModal.show" @ok="confirmEditModal" destroy-on-close centered>
      <a-form-model ref="form" :model="form" layout="vertical" :rules="rules">
        <a-form-model-item label="敏感词名称" prop="name">
          <a-textarea v-model="form.name" placeholder="请输入敏感词名称"></a-textarea>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
  import SensitiveWordsService from '@/io/sensitive_words.js';

  export default {
    name: 'SensitiveWordsManage',
    data() {
      let self = this;
      return {
        table: {
          loading: false,
          search: {
            name: null,
            status: []
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
          data: [],
          columns: [
            {
              title: '名称',
              dataIndex: 'word'
            },
            {
              title: '状态',
              scopedSlots: { customRender: 'state' }
            },
            {
              title: '操作',
              scopedSlots: { customRender: 'action' },
            }
          ]
        },
        form: {
          name: null,
        },
        rules: {
          name: [
            {
              required: true,
              message: '请填写敏感词名称'
            }
          ]
        },
        addModal: {
          title: '新增敏感词',
          show: false,
          loading: false
        },
        editModal: {
          id: null,
          title: '编辑敏感词',
          show: false,
          loading: false
        },
      }
    },
    activated() {
      this.initData();
    },
    methods: {
      newSensitiveWords() {
        this.form.name = null;
        this.addModal.show = true;
      },
      editSensitiveWords(data) {
        this.form.name = data.word;
        this.editModal.id = data.id;
        this.editModal.show = true;
      },
      deleteSensitiveWords(data) {
        let self = this;
        this.$confirm({
          title: '提示',
          content: '确认删除此敏感词？',
          onOk() {
            SensitiveWordsService.del([data.id]).then(res => {
              self.initData();
            }).catch(err => {});
          }
        });
      },
      confirmAddModal() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          this.addModal.loading = true;
          SensitiveWordsService.add(this.form.name).then(res => {
            this.$afterFormSubmit('创建成功', () => {
              this.initData();
            });
          }).catch(err => {}).finally(() => {
            this.addModal.show = false;
            this.addModal.loading = false;
          });
        });
      },
      confirmEditModal() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          this.editModal.loading = true;
          SensitiveWordsService.edit(this.editModal.id, this.form.name).then(res => {
            this.$afterFormSubmit('创建成功', () => {
              this.initData();
            });
          }).catch(err => {}).finally(() => {
            this.editModal.show = false;
            this.editModal.loading = false;
          });
        });
      },
      stateChange(data) {
        let checked = data.status === 1;
        data.stateLoading = true;
        SensitiveWordsService[checked ? 'disable' : 'enable'](data.id).then(res => {}).catch(err => {}).finally(() => {
          this.$afterFormSubmit(checked ? '关闭成功' : '开启成功');
          data.status = checked ? 0 : 1;
          data.stateLoading = false;
        });
      },
      searchTable() {
        this.table.page.current = 1;
        this.initData();
      },
      resetSearchTable() {
        this.table.search = {
          account: null,
          name: null,
          status: []
        };
        this.searchTable();
      },
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
      initData() {
        this.table.loading = true;
        return SensitiveWordsService.listPage(
          this.table.search.name,
          this.table.search.status,
          this.table.page.current,
          this.table.page.pageSize
        ).then(res => {
          this.table.data = res.data.map(val => {
            val.stateLoading = false;
            return val;
          });
          this.table.page.total = res.meta.pagination.total;
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      },
    },
  }
</script>

<style lang="less" scoped>

</style>